import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const templateMutations: UpdatesConfig['Mutation'] = {
  templateSetCreate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('templateSets', cache);
  },
  templateTokenCreate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('templateTokens', cache);
  },
  templateTokenValueCreate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('templateTokenValues', cache);
  },
  templateTokenValueDelete: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('templateTokenValues', cache);
  },
};

export default templateMutations;
